import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
    min-width: 0;
  `,
  errorMessage: ({ theme }) => css`
    margin-left: auto;
    display: flex;
    gap: 4px;
    padding: 3px 0;
    min-width: 0;
    color: ${theme.colors.tertiary.red[50]};

    & > svg {
      flex-shrink: 0;
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
